import { get,post,upload } from '@/utils/request'

const SUPPLIER_SERVICE = '/supplier-service/v1'
const ORDER_SERVICE = '/order-service/v1'
const WORKFLOW_SERVICE = '/workflow-service/v1'
const QUOTATION_SERVICE = '/quotation-service/v1'
const PROJECT_SERVICE = '/project-service/v1'

export function listInvitedForSupplier(params) {return get(SUPPLIER_SERVICE + '/portal/listInvited', params)}
export function saveSupplierBasicInfo(params) {return post(SUPPLIER_SERVICE + '/portal/saveBasicInfo', params)}
export function getSupplierBasicInfoByInviteId(params) {return get(SUPPLIER_SERVICE + '/portal/getSupplierBasicInfoByInviteId', params)}
// 潜在供应商---申请
export function submitRegisterApplyForm(params) {return post(SUPPLIER_SERVICE + '/portal/submitRegisterApplyForm', params)}
// 合格供应商---申请
export function submitRegisterApplyForm2(params) {return post(SUPPLIER_SERVICE + '/portal/submitRegisterApplyForm2', params)}

export function getApplyFormStatus(params) {return get(WORKFLOW_SERVICE + '/process/getCurrentWorkflowStatus', params)}

export function saveSupplierContacts(params) {return post(SUPPLIER_SERVICE + '/portal/saveSupplierContacts', params)}
export function listSupplierContracts(params) {return post(SUPPLIER_SERVICE + '/portal/listSupplierContracts', params)}
export function getBasicInfo(params) {return get(SUPPLIER_SERVICE + '/portal/getBasicInfo', params)}
export function updateBasicInfoById(params) {return post(SUPPLIER_SERVICE + '/portal/updateBasicInfoById', params)}

export function saveSupplierFactories(params) {return post(SUPPLIER_SERVICE + '/portal/saveSupplierFactories', params)}
export function listSupplierFactories(params) {return post(SUPPLIER_SERVICE + '/portal/listSupplierFactories', params)}

export function saveSupplierBusinessYears(params) {return post(SUPPLIER_SERVICE + '/portal/saveSupplierBusinessYears', params)}
export function listSupplierBusinessYears(params) {return post(SUPPLIER_SERVICE + '/portal/listSupplierBusinessYears', params)}

// 保存体系认证
export function saveSupplierCertifications(params) {return post(SUPPLIER_SERVICE + '/portal/saveSupplierCertifications', params)}
// 查询体系认证
export function listSupplierCertifications(params) {return post(SUPPLIER_SERVICE + '/portal/listSupplierCertifications', params)}
// 删除体系认证--根据ID
export function deleteSupplierCertificationsById(params) {return post(SUPPLIER_SERVICE + '/portal/deleteSupplierCertificationsById', params)}

// 保存主产品
export function saveSupplierProducts(params) {return post(SUPPLIER_SERVICE + '/portal/saveSupplierProducts', params)}
// 查询主产品
export function listSupplierProducts(params) {return post(SUPPLIER_SERVICE + '/portal/listSupplierProducts', params)}
// 删除主产品--根据ID
export function deleteSupplierProductsById(params) {return post(SUPPLIER_SERVICE + '/portal/deleteSupplierProductsById', params)}

// 保存主设备清单
export function saveSupplierEquipments(params) {return post(SUPPLIER_SERVICE + '/portal/saveSupplierEquipments', params)}
// 查询主设备清单
export function listSupplierEquipments(params) {return post(SUPPLIER_SERVICE + '/portal/listSupplierEquipments', params)}
// 删除主设备清单--根据ID
export function deleteSupplierEquipmentsById(params) {return post(SUPPLIER_SERVICE + '/portal/deleteSupplierEquipmentsById', params)}

export function uploadBasicInfo(params) {return upload(SUPPLIER_SERVICE + '/portal/uploadBasicInfo', params)}
export function getBasicInfoFiles(params) {return get(SUPPLIER_SERVICE + '/portal/getBasicInfoFiles', params)}
// 查询供应商基本信息表字段
export function findTablenamelist(params) {return get(SUPPLIER_SERVICE + '/portal/findTablenamelist',params)}
// 根据字段查询值-su_supplier_basic
export function findValueByTable(params) {return get(SUPPLIER_SERVICE + '/portal/findValueByTable',params)}
// 根据邀请ID获取工作流ID
export function getWorkflowIdByInviteFid(params) {return get(SUPPLIER_SERVICE + '/portal/getWorkflowIdByInviteFid',params)}
// 工作流退回上一节点
export function recallPrefixNode(params) {return get(SUPPLIER_SERVICE + '/portal/recallPrefixNode',params)}

// 保存变更信息分页查询
export function selectChangeInfoApplyPage(params) {return post(SUPPLIER_SERVICE + '/portal/selectChangeInfoApplyPage', params)}
// 保存变更信息--供应商变更
export function saveChange(params) {return post(SUPPLIER_SERVICE + '/portal/saveChange', params)}
// selectChangeInfo
export function selectChangeInfoList(params) {return get(SUPPLIER_SERVICE + '/portal/selectChangeInfoList', params)}
// 删除
export function deleteChange(params) {return get(SUPPLIER_SERVICE + '/portal/deleteChange', params)}
// 提交供应商信息变更申请
export function executeApply(params) {return post(SUPPLIER_SERVICE + '/portal/executeApply', params)}
/** 导出交货单导入模板 */
export function exportASNTemplate(params) {return upload(ORDER_SERVICE + "/upload-file/export-template-supplier", params)}
// 删除供应商信息变更
export function deleteSupplierChangeInfo(params) {return get(SUPPLIER_SERVICE + '/portal/deleteSupplierChangeInfo', params)}
/** 获取供应商在线报价数量 */
export function quotationCountByLoginUser() {
    return get(QUOTATION_SERVICE + '/quotation/quotationCountByLoginUser')
}
/** 供应商端获取已发布订单数量 */
export function publishedOrderCountByLoginUser() {
    return get(ORDER_SERVICE + '/orderTbl/publishedOrderCountByLoginUser')
}
/** 获取供应商索赔数量 */
export function supplyClaCountByLoginUser() {
    return get(SUPPLIER_SERVICE + '/supplierCla/getSupplierClaCountByVenderName')
}

export function getMaterialGroup(params) {return post(SUPPLIER_SERVICE + `/portal/getMaterialGroup`,params)}
export function queryBoxLabel(params) {return post(ORDER_SERVICE + `/boxLabelControl/queryBoxLabel`,params)}

///boxLabelControl/pushBoxLabel  同步接口，传参asnCodeList:[]，传选择行的asncode
export function pushBoxLabel(params) {return post(ORDER_SERVICE + `/boxLabelControl/pushBoxLabel`,params)}

export function queryLoadBill(params) {return post(ORDER_SERVICE + `/loadBill/queryLoadBill`,params)}

///boxLabelControl/pushBoxLabel  同步接口，传参asnCodeList:[]，传选择行的asncode
export function pushLoadBill(params) {return post(ORDER_SERVICE + `/loadBill/pushLoadBill`,params)}
